<script>
/**
 * Imports
 */
import SignupPackagesItem from "./../packages/SignupPackagesItem.vue";
import SignupPackagesTiers from "./../packages/SignupPackagesTiers.vue";
import SignupPackagesChappell from "./../packages/SignupPackagesChappell.vue";

/**
 * Component: Packages
 *
 * @author PH
 */
export default {
  props: ["groups", "fields", "settings"],

  components: { SignupPackagesItem, SignupPackagesTiers, SignupPackagesChappell }
};
</script>

<template>
  <div class="signup-packages">
    <signup-packages-tiers
      v-if="settings.tiers"
      v-bind:active="settings.tiers.current"
      v-bind:tiers="settings.tiers.items"
    ></signup-packages-tiers>

    <signup-packages-chappell
      v-if="settings.chappell"
      v-bind:active="settings.chappell.current"
      v-bind:chappell="settings.chappell.items"
    ></signup-packages-chappell>

    <signup-packages-item
      v-for="group in groups"
      v-bind:key="group.id"
      v-bind:id="group.id"
      v-bind:title="group.title"
      v-bind:groups="group.subgroups"
      v-bind:settings="group.settings"
      v-bind:fields="fields"
    ></signup-packages-item>
  </div>
</template>

